import axios from "axios";
import { WebConfig } from "../web-config";
import { getStoredPostId } from "./postSelection";
// Get API URL from environment variables
// const API_BASE_URL = process.env.REACT_APP_API_URL;

// if (!API_BASE_URL) {
//   // console.error('REACT_APP_API_URL is not defined in .env file');
//   throw new Error(
//     "REACT_APP_API_URL environment variable is required. Please create a .env file with REACT_APP_API_URL=http://localhost:5001"
//   );
// }

// Log the API URL for debugging (only once)
if (!window.__API_BASE_URL_LOGGED__) {
  if (process.env.NODE_ENV === "development") {
    // console.log('API Base URL:', API_BASE_URL);
  } else {
    // In production, log the base URL (without full path for security)
    // console.log('API Base URL configured:', API_BASE_URL ? 'Yes' : 'No');
  }
  window.__API_BASE_URL_LOGGED__ = true;
}

// Create axios instance
const api = axios.create({
  baseURL: `${WebConfig.REACT_APP_API_URL}/api`,
  headers: {
    "Content-Type": "application/json"
  }
});

const normalizeUserFullName = (value) => {
  if (Array.isArray(value)) {
    value.forEach((item) => normalizeUserFullName(item));
    return value;
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  // if (typeof value.full_name === 'string' && value.full_name.trim()) {
  //   value.name = value.full_name;
  // }

  Object.keys(value).forEach((key) => {
    normalizeUserFullName(value[key]);
  });

  return value;
};

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const activePostId = getStoredPostId();
    if (activePostId) {
      config.headers["X-Post-Id"] = activePostId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function initClients() {
  api.defaults.baseURL = `${WebConfig.REACT_APP_API_URL}/api`;
}

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => {
    if (response?.data) {
      normalizeUserFullName(response.data);
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and we haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken) {
          const response = await api.post(`/auth/refresh`, {
            refreshToken
          });

          const { accessToken, refreshToken: newRefreshToken } =
            response.data.data;
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", newRefreshToken);

          // Retry original request with new token
          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // Refresh failed, clear tokens and redirect to login
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        localStorage.removeItem("ssoToken");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
